/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMaintenanceReportQueryResult } from '../../models/get-maintenance-report-query-result';

export interface ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Params {
  Id?: string;
}

export function apiProjectMaintenanceReportGetProjectMaintenanceReportGet(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMaintenanceReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportGetProjectMaintenanceReportGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMaintenanceReportQueryResult>;
    })
  );
}

apiProjectMaintenanceReportGetProjectMaintenanceReportGet.PATH = '/api/ProjectMaintenanceReport/GetProjectMaintenanceReport';
